module.exports = __webpack_public_path__ + "img/p1-btn1.d2db4f12.png";